import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanDeactivate, CanLoad, CanMatch, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanLoad, CanMatch {
  constructor(private authService: AuthService, private router: Router) { }

  OnUnauthenicatedUser(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const userIdRouteParam = route.queryParams['approvalUserId'];
    const projectQuoteIdParam = route.queryParams['projectQuoteId'];
    const scheduleIdParam = route.queryParams['projectScheduleId'];
    const projectIdParam = route.queryParams['projectId'];
    var isInternalEmployeeList = route.routeConfig.path == 'admin-company/internal-employee-list';
    var isProjectQuoteForm = route.routeConfig.path == 'topmenu/project';
    if (isInternalEmployeeList && !!userIdRouteParam){
      this.router.navigate(['/user/user-login'], { state: { userApproval: userIdRouteParam },/*queryParams: { approvalUserId: userIdRouteParam } */});    
    } else if (isProjectQuoteForm && !!projectQuoteIdParam && !!scheduleIdParam && !!projectIdParam){
      this.router.navigate(['/user/user-login'], { state: { projectQuoteId: projectQuoteIdParam, scheduleId: scheduleIdParam, projectId: projectIdParam } });
    } else {
      this.router.navigate(['/user/user-login']);
    }
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree { 

      let authenticated = this.getAuthObs();
      authenticated.subscribe(
        (auth) => {
          if (!auth) {
            this.OnUnauthenicatedUser(route, state);
        }
      },
      (error) => {
        this.OnUnauthenicatedUser(route, state);       
      }
      );
      return authenticated;
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canMatch(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

  private getAuthObs(): Observable<boolean> {
    return this.authService.isAuthenticatedObs();
  }
}
